module.exports = __webpack_public_path__ + "static/media/rightParticles.dc477234.svg";